import React, { useState } from "react";
import axios from 'axios'; 
import { useHistory } from "react-router-dom";
const Emp = () => {

    
    let history = useHistory();
    const [user, setUser] = useState({
      name: "",
      email: "",
      designation:""
    
  
  });
  
  
      const { name, email, designation} = user;
      const onInputChange = e => {
        setUser({ ...user, [e.target.name]: e.target.value });
        // console.log();
      };
       
  
  
      const submitEmployeeRecord = async (e) => {

       

      e.preventDefault();
      e.target.reset();
     const data = await axios.post("http://localhost/apicrudphp/api/create.php",{
      name: name,
      email: email,
      designation: designation
          }).catch(function (error) {
        console.log(error);
      })
       console.log(data);
      alert('Data Inserted');
      };
     
    return (
        <>
              <section id="contact" class="contact">
      <div class="container">

    

        <div class="row mt-5">

          <div class="col-lg-12 mt-5 mt-lg-0">

            <form  onSubmit={submitEmployeeRecord}  class="php-email-form">
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <input type="text" name="name"
                   class="form-control" id="name"
                    placeholder="Your Name" 
                    value={name} onChange={e => onInputChange(e)}  />
                  <div class="validate"></div>
                </div>
                <div class="col-md-6 form-group">
                  <input type="email" class="form-control" name="email" id="email"
                   placeholder="Your Email" 
                   value={email} onChange={e => onInputChange(e)}  />
                  <div class="validate"></div>
                </div>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" name="designation" id="designation" placeholder="designation"
                   value={designation} onChange={e => onInputChange(e)}   />
                <div class="validate"></div>
              </div>
            
              <div class="text-center"><button type="submit">Send Message</button></div>
            </form>

          </div>

        </div>

      </div>
    </section>
        </>
    )
}

export default Emp
